interface PageSEOProps {
  schemas: Record<string, unknown>[];
}

export default function PageSEO({ schemas }: PageSEOProps) {
  const scripts = schemas.map((schema, index) => ({
    __html: JSON.stringify({
      '@context': 'https://schema.org',
      ...schema,
    }),
  }));

  return (
    <>
      {scripts.map((script, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={script}
        />
      ))}
    </>
  );
}